<bootstrap-popup [id]="id" [displaySubject]="displaySubject" [title]="'Personne Avertie'" >
    <pannel [title]="'Description'" [expandable]="true">
        <div *ngIf="documentPa?.id" class="row">
			<div class="col-md-6">
			<h4>Informations générales</h4>
				<ul>
					<li><b>N° PA :</b> {{ documentPa.numeroPa }}</li>
					<li><b>Commune :</b> {{ documentPa.commune || '-' }}</li>
				</ul>
				<h4>Site et lieu(x) de l'opération</h4>
				<ul>
					<li><b>Parcs :</b>
						<ul *ngIf="parcCodes.length; else noParc">
							<li *ngFor="let code of parcCodes">{{ code }}</li>
						</ul> <ng-template #noParc> <span>-</span> </ng-template></li>
				</ul>
		
				<h4>Planning</h4>
				<ul>
					<li><b>Date de début :</b> {{ documentPa.dateDebut |
						date:'dd/MM/yyyy' }}</li>
					<li><b>Date de fin :</b> {{ documentPa.dateFin |
						date:'dd/MM/yyyy' }}</li>
					<li><b>Durée (mois) :</b> {{ documentPa.duree }}</li>
				</ul>
			</div>

			<div class="col-md-6">
				<h4>Conditions de travail</h4>
				<ul>
					<li><b>Horaires :</b> {{ documentPa.horaires || '-' }}</li>
					<li><b>Nombre prévisible d’intervenants :</b> {{
						documentPa.nombreIntervenants }}</li>
				</ul>
				<h4>Description de l'opération</h4>
				<ul>
					<li *ngFor="let desc of splitDescription(documentPa.description)">
						{{ desc }}</li>
				</ul>
				<h4>Statut</h4>
				<ul>
					<li>{{ etatLabels[currentEtat] || currentEtat || '-' }}</li>
				</ul>
			</div>
		</div>
    </pannel>
    
    <pannel [title]="'Entreprises concernées'" [expandable]="true">
        <div class="row">
			<div class="col-md-6">
				<h4>
					Entreprise utilisatrice : <span class="entreprise-name"> {{ entrepriseData?.raisonSocialeEu }} </span>
				</h4>
		
				<ul *ngIf="entrepriseData" class="list-unstyled">
					<li><b>Responsable :</b>
					    <span [ngClass]="{
					        'text-success': entrepriseData?.euHasSigned,
					        'text-danger': !entrepriseData?.euHasSigned }">
					        {{ entrepriseData.nomPrenomResponsableEu }}
					    </span>
				    </li>
				</ul>
			</div>

			<div class="col-md-6">
				<h4>
					Entreprise extérieure : <span class="entreprise-name"> {{ entrepriseData?.raisonSocialeEe }} </span>
				</h4>
		
				<ul *ngIf="entrepriseData" class="list-unstyled">
					<li><b>Responsable :</b>
					    <span [ngClass]="{
					        'text-success': entrepriseData?.eeHasSigned,
					        'text-danger': !entrepriseData?.eeHasSigned }">
					        {{ entrepriseData.nomPrenomResponsableEe }}
					    </span>
					</li>
		
					<li><b>Intervenant(s) :</b>
						<ul *ngIf="getSignatairesByEntreprise(entrepriseData.idEntrepriseEe).length;">
							<li *ngFor="let s of getSignatairesByEntreprise(entrepriseData.idEntrepriseEe)">{{ getNomPrenom(s) }}</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
    </pannel>

    <div class="row">
        <div class="col-md-12">
            <div class="form-group text-center">
                <button type="button" class="btn btn-primary" style="margin-right: 10px" (click)="onCloseRequested()">
                    Fermer
                </button>
            </div>
        </div>
    </div>
</bootstrap-popup>
